module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "dark": _vm.darkMode
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.postingcreate
    }
  }, [_c('v-icon', [_vm._v("fas fa-plus")])], 1), _vm._v(" "), _c('div', {
    staticClass: "application",
    attrs: {
      "id": "App",
      "data-app": "true"
    }
  }, [_c('div', {
    staticClass: "application--wrap"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fa20b9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 446
// module chunks = 0